function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _array_without_holes(arr) {
    if (Array.isArray(arr)) return _array_like_to_array(arr);
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _iterable_to_array(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _non_iterable_spread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _to_consumable_array(arr) {
    return _array_without_holes(arr) || _iterable_to_array(arr) || _unsupported_iterable_to_array(arr) || _non_iterable_spread();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
function _ts_generator(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React from 'react';
import DashboardLayout from '../layouts/DashboardLayout';
import Heading from '../Heading';
import { FormattedMessage, useIntl } from 'react-intl';
import { Avatar, Button, HStack, Icon, Menu, MenuButton, MenuItem, MenuList, Switch, Text, Select, MenuDivider, useDisclosure, Stack } from '@chakra-ui/react';
import { WebRoutes } from '@/utils/constants';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronDown, faMagicWandSparkles, faPlus, faShield, faSync } from '@fortawesome/free-solid-svg-icons';
import { deleteIntegrationDiscordServer, getIntegrationDiscordServers, connectDiscordIntegrationServer, updateIntegrationDiscordServer } from '@/actions/IntegrationActions';
import useChannelStore from '@/stores/ChannelStore';
import { AuthProviders } from '@/types/server';
import { useFormik } from 'formik';
import SettingsPanel from '../SettingsPanel';
import InputModal from '../InputModal';
import { Helmet } from 'react-helmet';
import BackButton from '../BackButton';
import useDebouncedCallbackOnChange from '@/hooks/useDebouncedCallbackOnChange';
function ServerSelect(param) {
    var servers = param.servers, setSelectedServerId = param.setSelectedServerId, selectedServerId = param.selectedServerId, addDiscordIntegrationServer = param.addDiscordIntegrationServer;
    var selectedServer = React.useMemo(function() {
        if (servers.length === 0) {
            return null;
        }
        if (selectedServerId == null) {
            return servers[0];
        }
        return servers.find(function(server) {
            return server._id === selectedServerId;
        });
    }, [
        servers,
        selectedServerId
    ]);
    if (selectedServer == null) {
        return null;
    }
    return /*#__PURE__*/ _jsxs(Menu, {
        matchWidth: true,
        placement: "bottom",
        children: [
            /*#__PURE__*/ _jsx(MenuButton, {
                as: Button,
                width: "200px",
                isTruncated: true,
                justifyContent: "left",
                backgroundColor: "backgroundPrimary",
                leftIcon: /*#__PURE__*/ _jsx(Avatar, {
                    boxSize: 5,
                    src: selectedServer.icon
                }),
                rightIcon: /*#__PURE__*/ _jsx(Icon, {
                    size: "sm",
                    as: FontAwesomeIcon,
                    icon: faChevronDown
                }),
                _active: {
                    boxShadow: 'outline'
                },
                children: /*#__PURE__*/ _jsx(Text, {
                    isTruncated: true,
                    textAlign: "left",
                    children: selectedServer.displayName
                })
            }),
            /*#__PURE__*/ _jsxs(MenuList, {
                width: "200px",
                bgColor: "backgroundPrimary",
                boxShadow: "base",
                borderColor: "borderSecondary",
                children: [
                    servers.map(function(server) {
                        return /*#__PURE__*/ _jsx(MenuItem, {
                            icon: /*#__PURE__*/ _jsx(Avatar, {
                                boxSize: 5,
                                src: server.icon
                            }),
                            onClick: function() {
                                return setSelectedServerId(server._id);
                            },
                            children: /*#__PURE__*/ _jsx(Text, {
                                isTruncated: true,
                                textAlign: "left",
                                children: server.displayName
                            })
                        }, server._id);
                    }),
                    /*#__PURE__*/ _jsx(MenuDivider, {}),
                    /*#__PURE__*/ _jsx(MenuItem, {
                        icon: /*#__PURE__*/ _jsx(Icon, {
                            as: FontAwesomeIcon,
                            icon: faPlus
                        }),
                        onClick: function() {
                            return addDiscordIntegrationServer();
                        },
                        children: /*#__PURE__*/ _jsx(FormattedMessage, {
                            id: "57130E",
                            defaultMessage: "Add Discord Server"
                        })
                    })
                ]
            })
        ]
    });
}
export default function DiscordIntegration() {
    var intl = useIntl();
    var channel = useChannelStore(function(state) {
        return state.channel;
    });
    var _React_useState = _sliced_to_array(React.useState(false), 2), loading = _React_useState[0], setLoading = _React_useState[1];
    var _React_useState1 = _sliced_to_array(React.useState([]), 2), servers = _React_useState1[0], setServers = _React_useState1[1];
    var _React_useState2 = _sliced_to_array(React.useState(null), 2), selectedServerId = _React_useState2[0], setSelectedServerId = _React_useState2[1];
    var _React_useState3 = _sliced_to_array(React.useState(false), 2), deleting = _React_useState3[0], setDeleting = _React_useState3[1];
    var deleteServerModal = useDisclosure();
    var selectedServer = React.useMemo(function() {
        if (servers.length === 0) {
            return null;
        }
        if (selectedServerId == null) {
            return servers[0];
        }
        return servers.find(function(server) {
            return server._id === selectedServerId;
        });
    }, [
        servers,
        selectedServerId
    ]);
    React.useEffect(function() {
        if (channel == null) {
            return;
        }
        setLoading(true);
        getIntegrationDiscordServers(channel._id).then(function(data) {
            return setServers(data);
        }).finally(function() {
            return setLoading(false);
        });
    }, [
        channel
    ]);
    var formik = useFormik({
        initialValues: {
            providerId: '',
            displayName: '',
            icon: '',
            ownerId: '',
            roles: [],
            _id: '',
            createdAt: '',
            updatedAt: '',
            filtering: false,
            roleSyncing: false
        },
        onSubmit: /*#__PURE__*/ function() {
            var _ref = _async_to_generator(function(values, param) {
                var setSubmitting;
                return _ts_generator(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            setSubmitting = param.setSubmitting;
                            if (channel == null) {
                                return [
                                    2
                                ];
                            }
                            setSubmitting(true);
                            _state.label = 1;
                        case 1:
                            _state.trys.push([
                                1,
                                ,
                                3,
                                4
                            ]);
                            return [
                                4,
                                updateIntegrationDiscordServer(channel._id, values)
                            ];
                        case 2:
                            _state.sent();
                            setServers(function(prev) {
                                return prev.map(function(s) {
                                    return s._id === values._id ? values : s;
                                });
                            });
                            return [
                                3,
                                4
                            ];
                        case 3:
                            setSubmitting(false);
                            return [
                                7
                            ];
                        case 4:
                            return [
                                2
                            ];
                    }
                });
            });
            return function(values, _) {
                return _ref.apply(this, arguments);
            };
        }()
    });
    useDebouncedCallbackOnChange(formik, formik.submitForm);
    React.useEffect(function() {
        if (selectedServer == null) {
            return;
        }
        formik.resetForm({
            values: selectedServer
        });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        selectedServer
    ]);
    var addDiscordIntegrationServer = React.useCallback(/*#__PURE__*/ _async_to_generator(function() {
        return _ts_generator(this, function(_state) {
            if (channel == null || loading) {
                return [
                    2
                ];
            }
            setLoading(true);
            connectDiscordIntegrationServer(channel._id).then(function(server) {
                setServers(function(prev) {
                    return _to_consumable_array(prev).concat([
                        server
                    ]);
                });
                setSelectedServerId(server._id);
            }).catch(function() {}).finally(function() {
                return setLoading(false);
            });
            return [
                2
            ];
        });
    }), [
        channel,
        loading
    ]);
    var partServer = React.useCallback(/*#__PURE__*/ _async_to_generator(function() {
        return _ts_generator(this, function(_state) {
            if (channel == null || selectedServer == null || deleting) {
                return [
                    2
                ];
            }
            setDeleting(true);
            deleteIntegrationDiscordServer(channel._id, selectedServer._id).then(function() {
                setServers(function(prev) {
                    return prev.filter(function(server) {
                        return server._id !== selectedServer._id;
                    });
                });
                setSelectedServerId(null);
            }).finally(function() {
                return setDeleting(false);
            });
            return [
                2
            ];
        });
    }), [
        channel,
        deleting,
        selectedServer
    ]);
    var subscriberHeadingPanelTitle = (channel === null || channel === void 0 ? void 0 : channel.provider) === AuthProviders.YOUTUBE ? intl.formatMessage({
        id: "/mYICv",
        defaultMessage: [
            {
                type: 0,
                value: "Channel Members"
            }
        ]
    }) : intl.formatMessage({
        id: "u4eb+l",
        defaultMessage: [
            {
                type: 0,
                value: "Subscribers"
            }
        ]
    });
    var subscriberHeadingPanelDescription = (channel === null || channel === void 0 ? void 0 : channel.provider) === AuthProviders.YOUTUBE ? intl.formatMessage({
        id: "Xjxi4h",
        defaultMessage: [
            {
                type: 0,
                value: "Map a Discord role to your Channel Members."
            }
        ]
    }) : intl.formatMessage({
        id: "C8r7xH",
        defaultMessage: [
            {
                type: 0,
                value: "Map a Discord role to your Subscribers."
            }
        ]
    });
    var _formik_values_moderatorRole, _selectedServer_roles, _formik_values_twitchVIPRole, _selectedServer_roles1, _formik_values_subscriberRole, _selectedServer_roles2, _formik_values_regularRole, _selectedServer_roles3;
    return /*#__PURE__*/ _jsxs(DashboardLayout, {
        containerProps: {
            maxWidth: 'container.lg'
        },
        children: [
            /*#__PURE__*/ _jsx(Helmet, {
                title: intl.formatMessage({
                    id: "PO1zkS",
                    defaultMessage: [
                        {
                            type: 0,
                            value: "Discord Integration"
                        }
                    ]
                })
            }),
            /*#__PURE__*/ _jsx(BackButton, {
                fallbackParams: WebRoutes.INTEGRATIONS,
                children: /*#__PURE__*/ _jsx(FormattedMessage, {
                    id: "J2DV5y",
                    defaultMessage: "All Integrations"
                })
            }),
            /*#__PURE__*/ _jsx(HStack, {
                spacing: 4,
                children: /*#__PURE__*/ _jsx(Heading, {
                    subHeading: intl.formatMessage({
                        id: "F/Q+HF",
                        defaultMessage: [
                            {
                                type: 0,
                                value: "Integrate with Discord for commands, synced roles, and spam control."
                            }
                        ]
                    }),
                    children: /*#__PURE__*/ _jsx(FormattedMessage, {
                        id: "FvmV6q",
                        defaultMessage: "Discord"
                    })
                })
            }),
            /*#__PURE__*/ _jsxs(HStack, {
                spacing: 4,
                justifyContent: "space-between",
                alignItems: "flex-end",
                children: [
                    servers.length > 0 ? /*#__PURE__*/ _jsx(ServerSelect, {
                        servers: servers,
                        selectedServerId: selectedServerId,
                        setSelectedServerId: setSelectedServerId,
                        addDiscordIntegrationServer: addDiscordIntegrationServer
                    }) : /*#__PURE__*/ _jsx(Button, {
                        variant: "outline",
                        isLoading: loading,
                        backgroundColor: "backgroundPrimary",
                        onClick: function() {
                            return addDiscordIntegrationServer();
                        },
                        children: /*#__PURE__*/ _jsx(FormattedMessage, {
                            id: "57130E",
                            defaultMessage: "Add Discord Server"
                        })
                    }),
                    selectedServer != null ? /*#__PURE__*/ _jsx(Button, {
                        variant: "outline",
                        backgroundColor: "backgroundPrimary",
                        onClick: deleteServerModal.onOpen,
                        isLoading: deleting,
                        colorScheme: "red",
                        isDisabled: formik.isSubmitting,
                        children: /*#__PURE__*/ _jsx(FormattedMessage, {
                            id: "p1tNwr",
                            defaultMessage: "Part Server"
                        })
                    }) : null
                ]
            }),
            selectedServer != null && channel != null ? /*#__PURE__*/ _jsxs(_Fragment, {
                children: [
                    /*#__PURE__*/ _jsx(SettingsPanel, {
                        heading: intl.formatMessage({
                            id: "TY8Ho1",
                            defaultMessage: [
                                {
                                    type: 0,
                                    value: "Commands"
                                }
                            ]
                        }),
                        description: intl.formatMessage({
                            id: "dE9cc7",
                            defaultMessage: [
                                {
                                    type: 0,
                                    value: "Use your Nightbot commands in your Discord server."
                                }
                            ]
                        }),
                        icon: faMagicWandSparkles,
                        afterElement: /*#__PURE__*/ _jsx(Switch, {
                            isDisabled: true,
                            isChecked: true,
                            colorScheme: "primary"
                        })
                    }),
                    /*#__PURE__*/ _jsx(SettingsPanel, {
                        heading: intl.formatMessage({
                            id: "71AfYn",
                            defaultMessage: [
                                {
                                    type: 0,
                                    value: "Chat Moderation"
                                }
                            ]
                        }),
                        description: intl.formatMessage({
                            id: "Ec1LWM",
                            defaultMessage: [
                                {
                                    type: 0,
                                    value: "Automatically filter out spam, links, and unwanted messages."
                                }
                            ]
                        }),
                        icon: faShield,
                        afterElement: /*#__PURE__*/ _jsx(Switch, {
                            name: "filtering",
                            isChecked: formik.values.filtering,
                            onChange: formik.handleChange,
                            colorScheme: "primary"
                        })
                    }),
                    /*#__PURE__*/ _jsx(SettingsPanel, {
                        heading: intl.formatMessage({
                            id: "0LkAy7",
                            defaultMessage: [
                                {
                                    type: 0,
                                    value: "Role Syncing"
                                }
                            ]
                        }),
                        description: intl.formatMessage({
                            id: "+k2h8W",
                            defaultMessage: [
                                {
                                    type: 0,
                                    value: "Automatically add/remove eligible Discord Roles based on mapping."
                                }
                            ]
                        }),
                        icon: faSync,
                        afterElement: /*#__PURE__*/ _jsx(Switch, {
                            name: "roleSyncing",
                            isChecked: formik.values.roleSyncing,
                            onChange: formik.handleChange,
                            colorScheme: "primary"
                        })
                    }),
                    /*#__PURE__*/ _jsxs(Stack, {
                        spacing: 2,
                        children: [
                            /*#__PURE__*/ _jsx(Heading, {
                                size: "sm",
                                children: /*#__PURE__*/ _jsx(FormattedMessage, {
                                    id: "Dy4JYp",
                                    defaultMessage: "Role Mapping"
                                })
                            }),
                            /*#__PURE__*/ _jsx(Text, {
                                color: "textSecondary",
                                fontSize: "md",
                                children: /*#__PURE__*/ _jsx(FormattedMessage, {
                                    id: "ZZSb2+",
                                    defaultMessage: "Role mapping allows users to trigger Nightbot actions based on their Discord role."
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsx(SettingsPanel, {
                        heading: intl.formatMessage({
                            id: "zA95/o",
                            defaultMessage: [
                                {
                                    type: 0,
                                    value: "Moderator"
                                }
                            ]
                        }),
                        description: intl.formatMessage({
                            id: "VZ7PkH",
                            defaultMessage: [
                                {
                                    type: 0,
                                    value: "Map a Discord role to your Channel Moderators."
                                }
                            ]
                        }),
                        afterElement: /*#__PURE__*/ _jsx(Select, {
                            value: (_formik_values_moderatorRole = formik.values.moderatorRole) !== null && _formik_values_moderatorRole !== void 0 ? _formik_values_moderatorRole : '',
                            onChange: function(param) {
                                var value = param.target.value;
                                return formik.setFieldValue('moderatorRole', value);
                            },
                            children: ((_selectedServer_roles = selectedServer.roles) !== null && _selectedServer_roles !== void 0 ? _selectedServer_roles : []).map(function(role) {
                                return /*#__PURE__*/ _jsx("option", {
                                    value: role.providerId,
                                    children: role.displayName
                                }, role.providerId);
                            })
                        })
                    }),
                    channel != null && channel.provider === AuthProviders.TWITCH ? /*#__PURE__*/ _jsx(SettingsPanel, {
                        heading: intl.formatMessage({
                            id: "DrSbes",
                            defaultMessage: [
                                {
                                    type: 0,
                                    value: "Twitch VIP"
                                }
                            ]
                        }),
                        description: intl.formatMessage({
                            id: "hu0Ci/",
                            defaultMessage: [
                                {
                                    type: 0,
                                    value: "Map a Discord role to your Twitch VIPs."
                                }
                            ]
                        }),
                        afterElement: /*#__PURE__*/ _jsx(Select, {
                            value: (_formik_values_twitchVIPRole = formik.values.twitchVIPRole) !== null && _formik_values_twitchVIPRole !== void 0 ? _formik_values_twitchVIPRole : '',
                            onChange: function(param) {
                                var value = param.target.value;
                                return formik.setFieldValue('twitchVIPRole', value);
                            },
                            children: ((_selectedServer_roles1 = selectedServer.roles) !== null && _selectedServer_roles1 !== void 0 ? _selectedServer_roles1 : []).map(function(role) {
                                return /*#__PURE__*/ _jsx("option", {
                                    value: role.providerId,
                                    children: role.displayName
                                }, role.providerId);
                            })
                        })
                    }) : null,
                    /*#__PURE__*/ _jsx(SettingsPanel, {
                        heading: subscriberHeadingPanelTitle,
                        description: subscriberHeadingPanelDescription,
                        afterElement: /*#__PURE__*/ _jsx(Select, {
                            value: (_formik_values_subscriberRole = formik.values.subscriberRole) !== null && _formik_values_subscriberRole !== void 0 ? _formik_values_subscriberRole : '',
                            onChange: function(param) {
                                var value = param.target.value;
                                return formik.setFieldValue('subscriberRole', value);
                            },
                            children: ((_selectedServer_roles2 = selectedServer.roles) !== null && _selectedServer_roles2 !== void 0 ? _selectedServer_roles2 : []).map(function(role) {
                                return /*#__PURE__*/ _jsx("option", {
                                    value: role.providerId,
                                    children: role.displayName
                                }, role.providerId);
                            })
                        })
                    }),
                    /*#__PURE__*/ _jsx(SettingsPanel, {
                        heading: intl.formatMessage({
                            id: "zz8eSp",
                            defaultMessage: [
                                {
                                    type: 0,
                                    value: "Regular"
                                }
                            ]
                        }),
                        description: intl.formatMessage({
                            id: "e3PgR2",
                            defaultMessage: [
                                {
                                    type: 0,
                                    value: "Map a Discord role to your Channel Regulars."
                                }
                            ]
                        }),
                        afterElement: /*#__PURE__*/ _jsx(Select, {
                            value: (_formik_values_regularRole = formik.values.regularRole) !== null && _formik_values_regularRole !== void 0 ? _formik_values_regularRole : '',
                            onChange: function(param) {
                                var value = param.target.value;
                                return formik.setFieldValue('regularRole', value);
                            },
                            children: ((_selectedServer_roles3 = selectedServer.roles) !== null && _selectedServer_roles3 !== void 0 ? _selectedServer_roles3 : []).map(function(role) {
                                return /*#__PURE__*/ _jsx("option", {
                                    value: role.providerId,
                                    children: role.displayName
                                }, role.providerId);
                            })
                        })
                    }),
                    /*#__PURE__*/ _jsx(Text, {
                        color: "textSecondary",
                        fontSize: "sm",
                        children: /*#__PURE__*/ _jsx(FormattedMessage, {
                            id: "boPhjm",
                            defaultMessage: "Note: Nightbot will only sync roles to members that send chat messages within a 15 minute period. This includes both role grants and removals."
                        })
                    })
                ]
            }) : null,
            /*#__PURE__*/ _jsx(InputModal, {
                isOpen: deleteServerModal.isOpen,
                onClose: deleteServerModal.onClose,
                title: intl.formatMessage({
                    id: "p1tNwr",
                    defaultMessage: [
                        {
                            type: 0,
                            value: "Part Server"
                        }
                    ]
                }),
                description: intl.formatMessage({
                    id: "pw72Nx",
                    defaultMessage: [
                        {
                            type: 0,
                            value: "Are you sure you want to part from this server? This will remove all Nightbot functionality."
                        }
                    ]
                }),
                onSubmit: partServer,
                submitText: intl.formatMessage({
                    id: "p1tNwr",
                    defaultMessage: [
                        {
                            type: 0,
                            value: "Part Server"
                        }
                    ]
                })
            })
        ]
    });
}
